import { defineStore } from 'pinia';
import api from '../../api';

export const useFirmwareStore = defineStore('firmware', {
  state: () => ({
    upgradeLoading: false,
    restoreLoading: false,
    backupLoading: false,
    factoryLoading: false,
    options: [{
        value: 1,
        label: '',
        active: '-1'
      }, {
        value: 2,
        label: '',
        active: '-1'
      }],
    optionsUpdated: false
  }),
  actions: {
    uploadFirmware(params) {
      this.upgradeLoading = true;
      return api.firmware.uploadFirmware(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.upgradeLoading = false;
        });
    },
    firmwareUpgrade(params) {
      this.upgradeLoading = true;
      return api.firmware.firmwareUpgrade(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.upgradeLoading = false;
        });
    },
    restoreUpgrade(params) {
      this.restoreLoading = true;
      return api.firmware.restoreUpgrade(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.restoreLoading = false;
        });
    },
    saveBackup(params) {
      this.backupLoading = true;
      return api.firmware.saveBackup(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.backupLoading = false;
        });
    },
    factory(params) {
      this.factoryLoading = true;
      return api.firmware.factory(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.factoryLoading = false;
        });
    },
    async queryFirmwareList() {
      if (this.optionsUpdated) return;
       const response = await api.firmware.queryFirmwareList()
        if (response.resp.respCode === 0) {
          this.setImageInfo(response.deviceInfo)
        }
      // return api.firmware.queryFirmwareList()
      //   .then(response => {
      //       if (response.resp.respCode === 0) {
      //         this.setImageInfo(response.deviceInfo)
      //       }
      //     return response;

      //   })
      //   .catch(error => {
      //     throw error;
      //   });
    },
    setImageInfo(deviceInfo){
      this.options = this.options.map((item) => {
        item.label = deviceInfo[item.value == 1 ? 'activeImage' : 'backupImage']
        item.active = deviceInfo.runningImage == 'image1' ? 1 : 2
        return item
      })
      this.optionsUpdated = true;
    },
    // setOption(response) {
    //   this.options = this.options.map((item) => {
    //     item.label = response.deviceInfo[item.value == 1 ? 'activeImage' : 'backupImage']
    //     item.active = response.deviceInfo.runningImage == 'image1' ? 1 : 2
    //     return item
    //   })
    //   this.optionsUpdated = true;
    // },
    saveConfiguration(params) {
      return api.firmware.saveConfiguration(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
  },
});
